import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const AdaptabilityQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[8].icon}
          categoryName={categories[8].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="当进入全新环境（如新学校、新团队）时，你通常多久适应，即感到舒适并有效运作？" 
          value={formData.adaptationTime}
          onChange={(value) => handleInputChange('adaptationTime', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[8].icon}
          categoryName={categories[8].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="回忆过去几次你努力但结果不如预期的经历（如考试成绩不理想、比赛或自己领导的活动结果不理想），你通常如何反应和恢复？一般多久之后你再重新投入下一个任务？" 
          subtitle="（比如是一小时、一晚上，还是几天？没有对错～）"
          value={formData.failureResponse}
          onChange={(value) => handleInputChange('failureResponse', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[8].icon}
          categoryName={categories[8].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="当收到关于你工作的建设性批评时，你通常如何处理这些信息？" 
          subtitle="（例如：你是立即尝试应用，需要时间消化，还是倾向于保持自己的方式?）"
          value={formData.criticismHandling}
          onChange={(value) => handleInputChange('criticismHandling', value)}
          inputType="textarea"
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[8].icon}
          categoryName={categories[8].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="当你被分配到一个任务，没有明确指示、没有明确标准可循，你的感觉如何？这会让你感到刺激兴奋还是不安？" 
          value={formData.ambiguityComfort}
          onChange={(value) => handleInputChange('ambiguityComfort', value)}
          inputType="textarea"
        />
      );
    default:
      return null;
  }
};

export default AdaptabilityQuestions;